import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es una dieta estricta?',
    a: 'No. No elimina grupos de alimentos ni te pone a contar calorías. Se basa en sustituciones inteligentes para comer mejor sin restricciones extremas.'
  }, {
    q: '¿Necesito cocinar complicado?',
    a: 'Para nada. Las 32 recetas están diseñadas para ser simples, rápidas y con ingredientes comunes.'
  }, {
    q: '¿Sirve si como fuera de casa seguido?',
    a: 'Sí. Hay una guía completa para restaurantes y un capítulo dedicado a eventos sociales.'
  }, {
    q: '¿Funciona si tengo poco tiempo?',
    a: 'Sí. El enfoque es práctico y pensado para personas con vida real y agenda ocupada.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Inmediatamente después de tu compra recibes acceso al PDF desde cualquier dispositivo.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tienes 7 días para revisarlo. Si no te parece útil, te devolvemos tu dinero sin preguntas.'
  }];
  return <section className="py-24 bg-cream border-b border-gray-100" data-id="element-17">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <FadeIn data-id="element-19">
          <div className="text-center mb-16" data-id="element-20">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-warm-brown mb-6" data-id="element-21">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-22">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-23">
              <div className={`bg-white rounded-2xl border transition-all duration-200 overflow-hidden ${openIndex === index ? 'border-olive-green shadow-md' : 'border-warm-beige shadow-sm hover:border-olive-green/50'}`} data-id="element-24">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-25">
                  <span className="font-bold text-lg text-gray-900 pr-8" data-id="element-26">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-olive-green shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-27" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-28">
                  <p className="text-gray-600 leading-relaxed" data-id="element-29">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}